import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import useAppStore from './modules/app';
import useUserStore from './modules/user';
import useDocumentStore from './modules/document';
import useWorkflowStore from './modules/workflow';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export { useAppStore, useUserStore, useDocumentStore, useWorkflowStore };
export default pinia;
